const DEFAULT_API_URL = 'http://localhost:3000/api';

/** Full API base URL including the `/api` suffix (from REACT_APP_API_URL at build time). */
export function getApiBaseUrl(): string {
  const raw = process.env.REACT_APP_API_URL?.trim() || DEFAULT_API_URL;
  return raw.replace(/\/+$/, '');
}

/**
 * Backend origin for static assets served outside `/api` (e.g. `/uploads/...`).
 * Strips only a trailing `/api` path segment — never the host segment in `https://api.example.com`.
 */
export function getBackendOrigin(): string {
  const apiUrl = getApiBaseUrl();
  if (apiUrl.endsWith('/api')) {
    return apiUrl.slice(0, -4);
  }
  try {
    return new URL(apiUrl).origin;
  } catch {
    return 'http://localhost:3000';
  }
}

/** Resolve a backend-relative asset path to an absolute URL. */
export function resolveBackendAssetUrl(path?: string | null): string {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${getBackendOrigin()}${normalized}`;
}
